import type { ParsedQs } from 'qs';
import removeIndexNameFromQuery from './removeIndexNameFromQuery';
import type QueryParams from '~~/types/generic/queryParams';

export default (
  queryObj: ParsedQs, typesenseIndexName: string): ParsedQs => {

  queryObj = removeOldIndexNameWrapper(queryObj, typesenseIndexName);
  queryObj = addIndexNameToSortBy(queryObj, typesenseIndexName);

  if (!queryObj[typesenseIndexName]) {

    return {
      [typesenseIndexName]: {
        ...queryObj,
      },
    };

  }

  return queryObj;

};

const addIndexNameToSortBy = (queryObj: ParsedQs, typesenseIndexName: string): ParsedQs => {

  const sortByNotContainsIndexName = queryObj.sortBy && !queryObj.sortBy?.toString().includes(typesenseIndexName);

  if (sortByNotContainsIndexName) {

    queryObj.sortBy = `${typesenseIndexName}-${queryObj.sortBy}`;

  }

  return queryObj;

};

const removeOldIndexNameWrapper = (queryObj: ParsedQs, typesenseIndexName: string): ParsedQs => {

  const queryKeys = Object.keys(queryObj);
  const firstQueryKeyAsWrapper = queryKeys.length ? queryKeys[0] : null;
  const queryObjectIsWrappedByAShorterTypesenseIndexName =
  firstQueryKeyAsWrapper && typesenseIndexName !== firstQueryKeyAsWrapper &&
    typesenseIndexName.toLowerCase().includes(firstQueryKeyAsWrapper.toLowerCase());

  /**
   * Example: the correct typesense index name is `prod.pt-PT`, but it is
   * wrapped by `prod.PT`. In that case the old/wrong index name wrapper is
   * removed.
   */
  if (firstQueryKeyAsWrapper && queryObjectIsWrappedByAShorterTypesenseIndexName) {

    queryObj = removeIndexNameFromQuery(queryObj, firstQueryKeyAsWrapper);

  }

  return queryObj;

};
